import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase/config";

export async function sendMemberVerificationEmail({ storeId, storeName } = {}) {
  const email = auth.currentUser?.email;
  if (!email) return { ok: false };
  let language = "en";
  try {
    if (localStorage.getItem("language") === "fr") language = "fr";
  } catch {
    language = "en";
  }
  const send = httpsCallable(functions, "sendMemberVerificationEmail");
  const result = await send({
    email,
    storeId: storeId || "",
    storeName: storeName || "",
    language,
  });
  const data = result?.data || {};
  if (data.ok === false) {
    throw new Error(data.message || "Email was not sent");
  }
  return data;
}
